module.exports = __webpack_public_path__ + "static/media/img_quick2.72917eaf.png";